module.exports = __webpack_public_path__ + "img/product_82.46f5512.webp";